import React from 'react';
import moment from 'moment';

const INDEX_PROTECTOR = "Index Protector";

export const getIndexProtectorLabel = (indexProtectorId, isShort) => {

    if (!indexProtectorId) {
        console.log("Index Protector is using default value: 7");
        indexProtectorId = 7;
    }

    if (isShort) {
        if (indexProtectorId.indexOf("INDEX ACHIEVER") !== -1) {
            return (<span className={'index-protector-span'}>{indexProtectorId}</span>);
        } else {
            return (<span className={'index-protector-span'}>{INDEX_PROTECTOR} {indexProtectorId}</span>);
        }
    }

    let indexProtectorIdString = indexProtectorId.toString();

    switch(indexProtectorIdString) {
        case "7":
            return (<span className={'index-protector-span'}>{INDEX_PROTECTOR} {indexProtectorId}<sup>SM</sup></span>);
        case "5":
            return (<span className={'index-protector-span'}>{INDEX_PROTECTOR} {indexProtectorId}<sup>SM</sup></span>);
        case "5 MVA":
            return (<span className={'index-protector-span'}>{INDEX_PROTECTOR} {indexProtectorId}<sup>SM</sup></span>);
        case "4":
            return (<span className={'index-protector-span'}>{INDEX_PROTECTOR} {indexProtectorId}<sup>SM</sup></span>);
        case "INDEX ACHIEVER":
            return (<span className={'index-protector-span'}>Index Achiever®</span>);
        case "INDEX ACHIEVER ADVISORY":
            return (<span className={'index-protector-span'}>Index Achiever® Advisory</span>);
    }

    throw "Invalid Index Protector Id value: " + indexProtectorIdString;
};

export const convertAgeToDateOfBirth = (age) => {
    return moment().subtract('years', age);
};


// WEBPACK FOOTER //
// ./src/shared/common.js